module.exports = __webpack_public_path__ + "img/gain-item1.6a5d594b.png";